import { render } from "./BaseCardActions.vue?vue&type=template&id=96e25ae8&scoped=true"
import script from "./BaseCardActions.vue?vue&type=script&lang=js"
export * from "./BaseCardActions.vue?vue&type=script&lang=js"

import "./BaseCardActions.vue?vue&type=style&index=0&id=96e25ae8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e25ae8"]])

export default __exports__